import PopUpCard from '@app-ila/components/Card/PopUpCard';
import { getEmbedUrl } from '@app-ila/components/Utility/utils';
import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { BsArrowRightCircle } from 'react-icons/bs';
import { CgPlayButtonO } from 'react-icons/cg';
import YouTube from 'react-youtube';

/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

/**
 *
 * @param {Object} postData
 * @returns
 */
const TestimonialCard = ({ sectionContent, postData , sectionId}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [clickOption, setPopupCard] = useState({});
  const [opts, setOpts] = useState({});

  let progname = '';
  if (typeof window !== 'undefined') {
    let url = window.location.href;
    if (url.includes('/human-is-not-a-resource')) {
      progname = 'HINAR';
    } else if (url.includes('/family-enterprise-excellence')) {
      progname =
        'Family Enterprise Excellence - Mapping the Future of Your Business';
    }else if (url.includes('/insight-indepth')) {
      progname = 'Insight InDepth';
    }else if (url.includes('/insight')) {
      progname = 'INSIGHT - The DNA of Success, 2024';
    } else if (url.includes('/brand-insight')) {
      progname = 'Brand Insight - Decoding Branding';
    }else if (url.includes('/gen-a-entrepreneurship-bootcamp')) {
      progname = 'Gen A Entrepreneurship Bootcamp';
    }else if (url.includes('/harnessing-money-magic')) {
      progname = 'Harnessing Money Magic';
    }
  }

  const openPopup = (key, mentorname='') => {
    //Mixpanel
   if(key == "readMore"){
      const Mixpanel = mixPanel(window?.location.pathname);
      Mixpanel.track("sga_mentor_read_more_cta", {
        mentor_name: mentorname,
        program_name: progname,
      });
    }
    setPopupCard(key);
    onOpen();
  };


  useEffect(() => {
    setOpts({
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global.window]);

  const onReady = event => {
    event.target.playVideo();
  };

  // console.log('=>', postData?.tagType);

  return (
    <Flex
      flexDirection="column"
      maxW={{ base: '293.513px', md: '355px' }}
      textAlign="center"
    >
      <Box
        display="flex"
        flexDirection={{ md: 'row' }}
        marginTop="25px"
        className="Individual container"
      >
        <Box width={{ base: 'auto' }} pos="relative">
          {postData?.tagType && (
            <Box
              pos="absolute"
              bottom="10px"
              display={{ base: 'block', md: 'block' }}
              right={0}
              width="auto"
              padding="5px"
              minW={171}
              height={33}
              background={
                postData?.tagType?.toLowerCase()?.trim() == 'filling fast'
                  ? '#FF0000'
                  : '#D8A24C'
              }
            >
              <Text
                color="#fff"
                textAlign="center"
                fontFamily="var(--FedraSansCondensedMedium), sans-serif"
                fontSize="16px"
                fontStyle="normal"
                fontWeight="500"
                lineHeight="24px"
                textTransform="uppercase"
              >
                {postData?.tagType}
              </Text>
            </Box>
          )}
          <Image
            alt={postData.title}
            src={postData.image?.url}
            w={{ base: '293.513px', md: '305px', lg: '355px' }}
            h={{ base: '370.646px', md: '340px', lg: '447.16px' }}
            objectFit="cover"
            backgroundPosition="top center"
          />
        </Box>
      </Box>
      <Box textAlign={sectionId == "key-resource-leader-gen-a" ? "left" : ""}>
        <Text
          fontFamily="var(--FedraSansStd-medium), sans-serif"
          fontStyle="normal"
          letterSpacing="-0.098px"
          fontWeight={500}
          color="#fff"
          fontSize={{ base: '20px', md: '24px' }}
          lineHeight={{ base: '22.495px', md: '27.139px' }}
          mt={{ base: '30px', md: '30px' }}
        >
          {postData?.title}
        </Text>
        <Text
          color="#D4D4FA"
          lineHeight={{ base: '20px', md: '24px' }}
          fontSize={{ base: '14px', md: '16px' }}
          mt={{ base: '1px', md: '5px' }}
          fontWeight={400}
          fontStyle="normal"
        >
          {postData?.designation}
        </Text>
        <Text
          onClick={() => {
            openPopup('readMore', postData?.title);
          }}
          cursor="pointer"
          color="#F27123"
          fontFamily="var(--FedraSansStd-book)"
          fontSize={{ base: '16px', md: '18px' }}
          fontStyle="normal"
          fontWeight="450"
          lineHeight={{ base: '16.871px', md: '20.354px' }}
          letterSpacing={{ base: '-0.023px', md: '-0.027px' }}
          textDecoration="underline"
          display="flex"
          justifyContent={sectionId == "key-resource-leader-gen-a" ? "left" :"center"}
          mt={{ base: '16px', md: '26px' }}
          mb={sectionId === 'key-resource-leader-hmm' ? {base:'40px', md: '40px', lg:"40px"} : undefined}
          _hover={{ color: '#BA5010' }}
        >
          <Text as="span" mr="5px" textTransform="uppercase">
            {sectionContent?.readMorePlaceholder}
          </Text>
          <BsArrowRightCircle style={{ marginTop: '3px' }} />
        </Text>
        {postData.embedLink && (
          <Text
            onClick={() => {
              openPopup('viewExcerpts');
            }}
            cursor="pointer"
            color="#F27123"
            fontFamily="var(--FedraSansStd-book)"
            fontSize={{ base: '16px', md: '18px' }}
            fontStyle="normal"
            fontWeight="450"
            lineHeight={{ base: '16.871px', md: '20.354px' }}
            letterSpacing={{ base: '-0.023px', md: '-0.027px' }}
            textDecoration="underline"
            display="flex"
            justifyContent="center"
            mt={{ base: '16px', md: '26px' }}
            _hover={{ color: '#BA5010' }}
          >
            <Text as="span" mr="5px" textTransform="uppercase">
              {sectionContent?.viewExcerptsPlaceholder}
            </Text>
            <CgPlayButtonO style={{ marginTop: '3px' }} />
          </Text>
        )}
      </Box>

      {clickOption == 'viewExcerpts' && (
        <Box
          maxW={{ base: '100%', md: 'none', lg: '670px' }}
          px="0px"
          mt={{ base: '0px', md: '0px' }}
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="6xl"
            isCentered
            maxW={{ base: 'auto', md: '1256px' }}
            h={{ base: '100vh', md: '657px' }}
          >
            <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
            <ModalContent
              p={0}
              width={{ base: '100%', md: '95%' }}
              m="0"
              bg={{ base: '#000000' }}
              // transform={{ base: 'rotate(270deg)', md: 'none' }}
              h={{ base: '100%', md: 'auto' }}
            >
              <ModalCloseButton
                _hover={{ bg: '#fff', color: '#000' }}
                _active={{ bg: '#fff', color: '#000' }}
                _focus={{ bg: '#fff', color: '#000' }}
                zIndex="20"
                top={{ base: '12px', md: '-24px' }}
                bg="#fff"
                color="#000"
                w={{ base: '30px', md: '48px' }}
                height={{ base: '30px', md: '48px' }}
                right={{ base: '0', md: '-24px' }}
                className="closeButton"
                rounded="full"
              />
              <ModalBody p={0} m="0" w="100%" position="relative" height="100%">
                <Box
                  pos={{ base: 'static', md: 'static' }}
                  left="50%"
                  top="50%"
                  // transform={{ md: 'none', base: 'translate(-50%, -50%)' }}
                  display={{ base: 'flex', md: 'block' }}
                  justifyContent={{ base: 'center' }}
                  alignItems={{ base: 'center' }}
                  height="100%"
                >
                  <Box
                    bg="#FFFFFF"
                    onClick={onClose}
                    w="48px"
                    h="48px"
                    rounded="full"
                    _hover={{ bg: '#ffffff' }}
                    display={{ base: 'flex', md: 'none' }}
                    // placeItems="center"
                    justifyContent="center"
                    alignItems="center"
                    pos="absolute"
                    top="-145px"
                    left="-185px"
                    fontFamily="var(--FedraSansStd-Book), sans-serif"
                    zIndex="10"
                    cursor="pointer"
                    color="black"
                  >
                    x
                  </Box>
                  <Box
                    w="100%"
                    height={{ base: '100vh', md: '90vh', lg: '90vh' }}
                    id="msr-vid"
                    bg={{ base: '#000', md: '#fff' }}
                    p="14px"
                  >
                    <YouTube
                      videoId={getEmbedUrl(postData.embedLink)}
                      onReady={onReady}
                      opts={opts}
                      loading="lazy"
                      className="insightVideo"
                    />{' '}
                  </Box>
                </Box>
              </ModalBody>
            </ModalContent>
          </Modal>
        </Box>
      )}
      {clickOption == 'readMore' && (
        <Modal trapFocus={false}  isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            rounded="none"
            maxW={{ base: '90%', md: '1150px' }}
            height={{ base: '90%', md: '571px' }}
            padding={{ base: '50px 0 0', md: '40px 26px 31px 26px' }}
            backgroundColor={'white'}
          >
            <ModalCloseButton />
            <ModalBody pt={{ base: '0' }} overflow="auto">
              <PopUpCard postData={postData} />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      <style global jsx>
        {`
          .insightVideo {
            height: 100%;
          }
          .insightVideo iframe {
            height: inherit;
          }
          .closeButton:hover {
            background: #ffffff !important;
            color: black !important;
          }
          .textWhite p {
            // font-family: 'var(--FedraSansStd-book)', sans-serif;
          }
          .textWhite p strong {
            // font-family: 'var(--FedraSansStd-medium)', sans-serif;
            font-weight: 400;
          }
          @media only screen and (max-width: 550px) {
            .insightVideo {
              width: 100%;
              height: 100%;
            }
            .insightVideo iframe {
              width: 100%;
              height: 100%;
            }
          }
        `}
      </style>
    </Flex>
  );
};

export default TestimonialCard;
